import {
  jb_navigation_tags_css_default
} from "./chunk.IT6VKROY.js";
import {
  o
} from "./chunk.BLBOUOUQ.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  setLink
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  respondTo
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-navigation-tags/jb-navigation-tags.ts
var JbNavigationTags = class extends Spaceable(i) {
  constructor() {
    super(...arguments);
    this.ARIALABELS_DEFAULT = {
      active: "Active"
    };
    this._handleResize = () => {
      this._calculateShowButton();
    };
    this._showButton = false;
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("resize", this._handleResize);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("resize", this._handleResize);
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (changedProperties.has("items")) {
      this._initializeLinks();
    }
  }
  firstUpdated() {
    setTimeout(() => {
      this._calculateShowButton();
    }, 0);
  }
  _calculateShowButton() {
    const element = this._list.firstElementChild;
    if (!element) {
      this._showButton = false;
      return;
    }
    const styles = window.getComputedStyle(element);
    const heightWithMargin = element.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    const actualHeight = this._list.scrollHeight - 30;
    if (respondTo({ xs: "mobile", sm: "desktop" }) === "mobile") {
      if (actualHeight >= heightWithMargin * 4) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    } else {
      if (actualHeight >= heightWithMargin * 2) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    }
    this._setTabindexes();
  }
  _getContentSpacingProperties() {
    return { grid: true, colsLgUp: 10, type: "navigation-tags" };
  }
  // The template only binds the href; the rest of the link (market URLs, link data, target) and
  // the link events come from `setLink`, as for every other link.
  _initializeLinks() {
    this.renderRoot.querySelectorAll(".list-item > a").forEach((anchor, index) => {
      const link = this.items[index]?.link;
      if (link?.href) {
        setLink(anchor, link);
      }
    });
  }
  _renderItem(item, indx) {
    return b`<li
      class="list-item animate-left-bottom ${item.tag === this.activeItem ? "active" : ""}"
      role="${this.items.length === 1 ? "presentation" : A}"
      data-search-action-url=${o(item.searchAction)}
      data-search-suggest-url=${o(item.suggestUrl)}
      data-index="${indx}"
      @click=${(evt) => {
      this._setActive(evt.target);
    }}
      @keyup=${(evt) => {
      this._setActive(evt.target);
    }}
    >
      <a
        href=${o(item.link.href)}
        data-tag=${item.tag}
        @click=${this._trackClicks}
        >${item.tag}${item.tag === this.activeItem ? b`<span class="sr-only"> (${this.ARIALABELS_DEFAULT.active})</span>` : A}</a
      >
    </li>`;
  }
  _setActive(elm) {
    const parentElement = elm.closest("ul");
    const currentActive = parentElement.querySelector(".active");
    if (currentActive) {
      currentActive.classList.remove("active");
      const srElement2 = currentActive.querySelector(".sr-only");
      srElement2.remove();
    }
    const currentLi = elm.closest("li");
    currentLi.classList.add("active");
    const srElement = document.createElement("span");
    srElement.classList.add("sr-only");
    srElement.innerHTML = ` (${this.ARIALABELS_DEFAULT.active})`;
    elm.appendChild(srElement);
  }
  _setTabindexes() {
    const listHeight = this._list.offsetHeight;
    const listTopPosition = this._list.offsetTop;
    this.renderRoot.querySelectorAll(".list-item").forEach((lmt) => {
      const itemLink = lmt.querySelector("a");
      itemLink.removeAttribute("tabindex");
      lmt.removeAttribute("aria-hidden");
      if (lmt.offsetTop - listTopPosition > listHeight) {
        lmt.setAttribute("aria-hidden", "");
        itemLink.setAttribute("tabindex", "-1");
      }
    });
  }
  _trackClicks(evt) {
    const eventTarget = evt.composedPath()[0];
    const tag = eventTarget.dataset.tag ?? evt.detail.label;
    const url = eventTarget.href ?? evt.detail.newValue;
    this.dispatchEvent(
      new CustomEvent("jb-navigation-tags:filter", {
        detail: {
          tag,
          url
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return b`<nav
      role="navigation"
      aria-label="Tag navigation"
      class="navigation-tags ${this.type}"
      part="navigation"
    >
      <input
        type="checkbox"
        id="checkbox"
        @change=${() => {
      setTimeout(() => {
        this._setTabindexes();
      }, 300);
      this.requestUpdate();
    }}
      />
      ${this.heading ? b`<jb-section-headline .headline=${this.heading}></jb-section-headline>` : A}
      <ul
        class="list"
        part="list"
        role="${this.items.length === 1 ? "presentation" : A}"
      >
        ${this.items.map((item, indx) => this._renderItem(item, indx))}
      </ul>
      ${this._showButton ? b` <div class="title-wrapper">
              <label
                for="checkbox"
                data-open="${this.toOpenText}"
                data-close="${this.toCloseText}"
                tabindex="0"
                class=${e2({
      expanded: this._input?.checked
    })}
                @keydown=${(evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this._input.checked = !this._input.checked;
        setTimeout(() => {
          this._setTabindexes();
        }, 300);
        this.requestUpdate();
      }
    }}
              >
                <jb-icon iconName="material:keyboard_arrow_down"></jb-icon>
              </label>
            </div>` : A}
    </nav>`;
  }
};
JbNavigationTags.styles = [reset_css_default, jb_navigation_tags_css_default];
__decorateClass([
  n()
], JbNavigationTags.prototype, "activeItem", 2);
__decorateClass([
  n({ type: Object })
], JbNavigationTags.prototype, "ariaLabels", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "heading", 2);
__decorateClass([
  n({ type: Array })
], JbNavigationTags.prototype, "items", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toCloseText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toOpenText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "type", 2);
__decorateClass([
  e("input")
], JbNavigationTags.prototype, "_input", 2);
__decorateClass([
  e(".list")
], JbNavigationTags.prototype, "_list", 2);
__decorateClass([
  r()
], JbNavigationTags.prototype, "_showButton", 2);
JbNavigationTags = __decorateClass([
  customElement("jb-navigation-tags")
], JbNavigationTags);

export {
  JbNavigationTags
};
